/// <reference types="vite/client" />
// The MyMentor logo, for a platform that has no name or logo of its own: on
// a light surface, or on a dark one.

import logo from '../assets/logo.svg'
import logoInverse from '../assets/logo-inverse.svg'
import mark from '../assets/logo-mark.svg'
import markInverse from '../assets/logo-mark-inverse.svg'

const BRAND = 'MyMentor'

/**
 * `on` names the background: "light" draws the green logo, "dark" the white
 * and mint one. `compact` keeps only the mark, for the folded sidebar.
 */
export function Logo({ on = 'light', compact }: { on?: 'light' | 'dark'; compact?: boolean }) {
  const src = compact ? (on === 'dark' ? markInverse : mark) : on === 'dark' ? logoInverse : logo
  return (
    <img
      className={compact ? 'logo logo--mark' : 'logo'}
      src={src}
      alt={BRAND}
      width={compact ? 32 : 152}
      height={32}
      draggable={false}
    />
  )
}
